import { useSiisToast } from "./useSiisToast";
import axios from "axios";
import Vue from "vue";

export function useRest() {
  const toast = useSiisToast();

  function get(options) {
    return new Promise(async (resolve, reject) => {
      try {
        if (typeof options === "string") options = { url: options };
        if (options.url.search("http://") < 0 && options.url.search("https://") < 0)
          options.url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}${options.url}`;

        let params = options.params || {};
        const config = {
          withCredentials: true,
          params,
          headers: { ...options.headers },
        };

        if (options.responseType) {
          config.responseType = options.responseType;
        }

        let response = await axios.get(options.url, config);
        let result = await processResponse(response, options);
        return resolve(result);
      } catch (e) {
        console.log("response get error", e);
        processResponse(e.response, options);
        return reject(e);
      }
    });
  }

  async function post(options) {
    try {
      if (options.url.search("http://") < 0 && options.url.search("https://") < 0)
        options.url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}${options.url}`;

      let params = options.params || {};
      const response = await axios.post(
        options.url,
        options.formData,
        { withCredentials: true, params },
        {
          headers: { ...options.headers },
        }
      );

      return await processResponse(response, options);
    } catch (e) {
      return await processResponse(e.response, options);
    }
  }

  async function put(options) {
    try {
      if (options.url.search("http://") < 0 && options.url.search("https://") < 0)
        options.url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}${options.url}`;

      let params = options.params || {};
      const response = await axios.put(
        options.url,
        options.formData,
        { withCredentials: true, params },
        {
          headers: { ...options.headers },
        }
      );

      return await processResponse(response, options);
    } catch (e) {
      return await processResponse(e.response, options);
    }
  }

  async function del(options) {
    try {
      if (options.url.search("http://") < 0 && options.url.search("https://") < 0)
        options.url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}${options.url}`;

      const response = await axios.delete(
        options.url,
        { withCredentials: true },
        {
          headers: { ...options.headers },
        }
      );

      return await processResponse(response, options);
    } catch (e) {
      return await processResponse(e.response, options);
    }
  }

  function processResponse(response, options) {
    return new Promise(async (resolve, reject) => {
      if (!Vue.prototype.$offline.onlineMode) {
        toast.open({
          message: "OFFLINE SIIS: Acción no disponible.",
          position: "top-right",
          type: "error",
          duration: 3000,
        });
        return reject({});
      }

      if (options.responseType === "blob") {
        return resolve(response);
      }

      let successMsg = options.success || "La carga se realizo con exito.";

      let errAlert = () => {
        let msg = typeof response.data == "object" ? JSON.stringify(response.data) : response.data;
        alert(msg);
      };
      // console.log("response: ", response)
      if (response.status === 409 && response.data.code) {
        toast.open({
          message: response.data.message,
          position: "top-right",
          type: "error",
          duration: 5000,
        });
        return reject(response);
      }
      if (!response) console.error("response: ", response, options);

      if (!response || (response && response.status == "401")) {
        try {
          if (response.data.error == "Unauthorized") {
            let msg =
              "La sesion ha caducado o no tiene permiso para la accion que desea realizar. Abriremos una nueva pestaña para que vuelva a loguearse. Luego de loguearse vuelva a intentarlo.";
            if (toast.containsInQueue(msg)) {
              toast.open({
                message: msg,
                position: "top-right",
                type: "error",
                duration: 5000,
                onClick: errAlert,
              });
              setTimeout(() => {
                window.open("/login?closeTab", "_blank");
              }, 3000);
            }
            return reject(response);
          }
        } catch (e) {
          console.error("Error: ", e, response);
          toast.open({
            message:
              "Ups! Algo fallo, te pedimos disculpas y te ayudaremos a resolverlo. Por favor, haz click en este cartel rojo, te aparecera un nuevo mensaje, envia una captura de pantalla con esa información a la mesa de ayuda tecnica.",
            position: "top-right",
            type: "error",
            duration: 0,
            onClick: () => alert(e),
          });
          return reject(response);
        }
        if (response) {
          toast.open({
            message:
              "Ups! Algo fallo, te pedimos disculpas y te ayudaremos a resolverlo. Por favor, haz click en este cartel rojo, te aparecera un nuevo mensaje, envia una captura de pantalla con esa información a la mesa de ayuda tecnica.",
            position: "top-right",
            type: "error",
            duration: 0,
            onClick: errAlert,
          });
          return reject(response);
        }
      } else if (
        (response && response.status != "200" && response.status != "201") ||
        (response.data &&
          typeof response.data.error === "string" &&
          response.data.error.trim() !== "")
      ) {
        toast.open({
          message: "Ocurrio un error al cargar.",
          position: "top-right",
          type: "error",
          duration: 3000,
          onClick: errAlert,
        });
        return reject(response);
      }
      toast.verifyAndOpen({
        message: successMsg,
        position: "top-right",
        type: "success",
        duration: 3000,
      });
      return resolve(response);
    });
  }

  return {
    get,
    post,
    put,
    del,
  };
}
